import { trigger, transition, style, animate, sequence } from '@angular/animations';
import { Component, inject } from '@angular/core';
import { IBanner } from '@mogenius/core/interfaces/banner.interface';
import { NotificationService } from '@mogenius/shared/services/notification.service';
import { NotificationBannerListItemComponent } from './notification-banner-list-item/notification-banner-list-item.component';

@Component({
    selector: 'mo-notification-banner-list',
    templateUrl: './notification-banner-list.component.html',
    styleUrl: './notification-banner-list.component.scss',
    animations: [
        trigger('fadeSlideInOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(10px)' }),
                animate('500ms', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', sequence([animate('500ms', style({ opacity: 0 }))]))
        ])
    ],
    imports: [NotificationBannerListItemComponent]
})
export class NotificationBannerListComponent {
  private readonly _notificationService = inject(NotificationService);


  public closeBanner(banner: IBanner): void {
    if (!banner?.id) return;
    this._notificationService.removeBanner(banner.id);
  }

  get banners(): IBanner[] {
    return this._notificationService.banners;
  }
}
